<template>
  <b-container>
    <!-- 导航头 -->
    <nav-bar></nav-bar>
    <!-- 具体内容展示区 -->
    <router-view />
    <!-- 页脚区 -->
    <foot-zone />
  </b-container>
</template>

<script>
import NavBar from '@/components/navbar'
import FootZone from './components/footzone'

export default {
  name: 'AppMain',
  components: {
    NavBar,
    FootZone
  }
}
</script>

<style lang="scss">
.breadcrumb {
  font-size: 16px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.mult-line-overflow {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  word-wrap: break-word;
  overflow: hidden;
}
.line-indent {
  text-indent: 20px;
}
.content-font {
  font-size: 16px;
  line-height: 28px;
}
</style>

<style lang="scss" scoped>
@media (min-width: 1200px) {
  .container,
  .container-sm,
  .container-md,
  .container-lg,
  .container-xl {
    max-width: 1210px;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
